import ConsoleLogin from '@/components/console/ConsoleLogin.vue'
import ConsoleHome from '@/components/console/ConsoleHome.vue'
import ConsoleUsers from '@/components/console/ConsoleUsers.vue'
import ConsoleRecords from '@/components/console/ConsoleRecords.vue'
import ConsoleStatistics from '@/components/console/ConsoleStatistics.vue'

export default [
  { path: '/console/statistics', name: 'console-statistics', component: ConsoleStatistics, meta: { consoleAuth: true } },
  ...['members', 'exchanges', 'reports'].map(kind => ({ path: `/console/${kind}`, name: `console-${kind}`, component: ConsoleRecords, props: { kind }, meta: { consoleAuth: true } })),
  {
    path: '/console/login',
    name: 'console-login',
    component: ConsoleLogin,
    meta: { consoleGuest: true },
  },
  {
    path: '/console',
    name: 'console-home',
    component: ConsoleHome,
    meta: { consoleAuth: true },
  },
  {
    path: '/console/users',
    name: 'console-users',
    component: ConsoleUsers,
    meta: { consoleAuth: true, consoleRole: 'SUPER_ADMIN' },
  },
]
